import Dialog from "@/components/Dialog";
import Button from "@/components/Button";

interface FinalizeScoresErrorModalProps {
  open: boolean;
  onClose: () => void;
  missingRegistrantScores: number;
  missingEventInformation: number;
  missingStatus: number;
}

export default function FinalizeScoresErrorModal({
  open,
  onClose,
  missingRegistrantScores,
  missingEventInformation,
  missingStatus
}: FinalizeScoresErrorModalProps) {
  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline={`Finalize Scores`}
      actions={
        <>
          <Button
            onClick={() => {
              onClose();
            }}
          >
            Go Back
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4" data-testid="finalize-error-dialog">
        <div className="flex flex-col">
          {missingStatus > 0 && (
            <div className="text-label-large" data-testid="missing-status">
              Missing Absentee Status: {missingStatus}
            </div>
          )}
          {missingRegistrantScores > 0 && (
            <div className="text-label-large" data-testid="missing-registrant-info">
              Missing Registrant Scores: {missingRegistrantScores}
            </div>
          )}
          {missingEventInformation > 0 && (
            <div className="text-label-large" data-testid="missing-event-info">
              Missing Event Information: {missingEventInformation}
            </div>
          )}
        </div>
        <div>
          {missingRegistrantScores > 0 && (
            <div className="text-body-medium">
              Please provide scores or statuses for all participants before finalizing.
            </div>
          )}
          {missingStatus > 0 && (
            <div className="text-body-medium">Please provide a status for all absentees before finalizing.</div>
          )}
          {missingEventInformation > 0 && (
            <div className="text-body-medium">Please provide all event setup information before finalizing.</div>
          )}
        </div>
      </div>
    </Dialog>
  );
}
